import React from 'react'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'

import {
  candidates,
  sumOfCandidates,
} from '../data/OccupationalAssessmentCandidatesFrom17and18'

const OccupationalAssessmentCandidateTable = ({ langKey, className }) => {
  return (
    <div className={`${className}`}>
      <table className="mb-8">
        <colgroup>
          <col style={{ width: '60%', minWidth: '60%' }}></col>
          <col style={{ width: '40%', minWidth: '40%' }}></col>
        </colgroup>
        <thead>
          <tr>
            <th colSpan="2"><FormattedMessage id="Occupational Assessment Candidates - Academic Year 2017/18" /></th>
          </tr>
          <tr>
            <th><FormattedMessage id="Items" /></th>
            <th><FormattedMessage id="Candidates" /></th>
          </tr>
        </thead>

        <tbody>
          {
            candidates.map((candidate, i) => (
              <tr key={i}>
                <td>{ candidate.name[langKey] }</td>
                <td className="text-right">{ numeral(candidate.count).format('0,0') }</td>
              </tr>
            ))
          }
          <tr className="table-footer">
            <td><FormattedMessage id="Total" /></td>
            <td className="number">{ numeral(sumOfCandidates).format('0,0') }</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

OccupationalAssessmentCandidateTable.defaultProps = {
  className: '',
}

export default OccupationalAssessmentCandidateTable
